class Animation25 {
  constructor() {
    this.container = document.querySelector('.ns-header-25');
    if (!this.container) return;

    this.rectOrder = ['1', '2', '3', '4'];

    this.bindAnimation();
  }

  /** @returns {'q1' | 'q2' | 'q3' | null} */
  getQuarterlyAnimationVariant() {
    if (this.container.classList.contains('animation-q1')) return 'q1';
    if (this.container.classList.contains('animation-q2')) return 'q2';
    if (this.container.classList.contains('animation-q3')) return 'q3';
    return null;
  }

  /**
   * Q1–Q3: gleiche gestaffelte Einblendung wie ohne Varianten (`--drawn` in bindAnimation).
   * Unterschied zur Normalversion: auf das Wobble wird nicht gewartet — nach kurzer gemeinsamer
   * Sichtbarkeit aller vier Kästen (Einblend-Transition abgeschlossen) werden die überzähligen ausgeblendet.
   * Die verbleibenden Kästen laufen mit Wobble weiter wie gewohnt.
   *
   * @param {'q1' | 'q2' | 'q3'} variant
   */
  scheduleQuarterlyRectFadeOut(variant, isEsg, fadeDuration, delayBetween, startDelay) {
    if (isEsg) return;

    const keepByVariant = {
      q1: ['2'],
      q2: ['2', '3'],
      q3: ['2', '3', '4'],
    };
    const keep = new Set(keepByVariant[variant]);

    const lastIndex = this.rectOrder.length - 1;
    const lastDrawMs = startDelay + lastIndex * (fadeDuration + delayBetween);
    /** Kurz alle vier auf voller Opazität, bevor die Ausblendung startet (ohne Wobble abzuwarten). */
    const holdAfterAllVisibleMs = 450;
    const fadeOutAfterMs = lastDrawMs + fadeDuration + holdAfterAllVisibleMs;

    const fadeOutDurationMs = 1200;
    const hideOthers = () => {
      this.rectOrder.forEach((suffix) => {
        if (keep.has(suffix)) return;
        const rect = this.container.querySelector(`.ns-header-25__rect--${suffix}`);
        if (!rect) return;

        const currentOpacity = window.getComputedStyle(rect).opacity;
        rect.style.animation = 'none';
        rect.style.transition = 'none';
        rect.style.opacity = currentOpacity;
        void rect.getBoundingClientRect();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            rect.style.transition = `opacity ${fadeOutDurationMs}ms ease-out`;
            rect.style.opacity = '0';
            rect.classList.add('ns-header-25__rect--q-hidden');
          });
        });
      });
    };

    setTimeout(hideOthers, fadeOutAfterMs);
  }

  bindAnimation() {
    const isEsg = this.container.classList.contains('esg-animation-25');
    const rectanglesEl = this.container.querySelector(
      isEsg ? '.ns-header-25__rectangles--esg' : '.ns-header-25__rectangles'
    );
    if (!rectanglesEl) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.container.classList.add('start');
        rectanglesEl.classList.add(
          isEsg ? 'ns-header-25__rectangles--esg--ready' : 'ns-header-25__rectangles--ready'
        );
      });
    });

    const fadeDuration = 500;
    const delayBetween = 350;
    const startDelay = 400;

    const quarterlyVariant = this.getQuarterlyAnimationVariant();

    if (quarterlyVariant) {
      this.scheduleQuarterlyRectFadeOut(
        quarterlyVariant,
        isEsg,
        fadeDuration,
        delayBetween,
        startDelay
      );
    }

    if (isEsg) {
      const esgOrder = ['1', '2', '3', '4', '5', '6', '7', '8'];
      esgOrder.forEach((suffix, index) => {
        const rect = this.container.querySelector(`.ns-header-25__rect--esg--${suffix}`);
        if (!rect) return;
        setTimeout(() => {
          rect.classList.add('ns-header-25__rect--esg-drawn');
        }, startDelay + index * (fadeDuration + delayBetween));
      });
    } else {
      this.rectOrder.forEach((suffix, index) => {
        const rect = this.container.querySelector(`.ns-header-25__rect--${suffix}`);
        if (!rect) return;
        setTimeout(() => {
          rect.classList.add('ns-header-25__rect--drawn');
        }, startDelay + index * (fadeDuration + delayBetween));
      });
    }
  }
}

export default Animation25;
